/**
 * Number and currency formatting utilities
 */

/**
 * Format numbers with thousand separators (1,234 format)
 * @param num - Number to format
 * @returns Formatted string or original value if invalid
 */
export function formatNumber(num: number | string | null | undefined): string {
  if (num === null || num === undefined || num === "" || isNaN(Number(num))) {
    return String(num ?? "");
  }
  return parseInt(String(num), 10)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

/**
 * Format price as USD currency
 * @param amount - Amount in dollars
 * @returns Formatted price string (e.g., "$1,234.56")
 */
export function formatPrice(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
